import { InjectionToken } from '@angular/core';
export interface RuntimeConfig {
  apiBaseUrl: string;
  demoMode: boolean;
  entra: { tenantId: string; clientId: string; apiScope: string };
}
export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('runtime config');
export function isLocalDemo(config: RuntimeConfig, hostname = window.location.hostname): boolean {
  return config.demoMode && ['localhost', '127.0.0.1', '[::1]'].includes(hostname);
}
